import { panelTypes } from '../../../../common/panel/constants'
import { getUnique } from '../../../../helpers/common'
import {
  typeComponentBank,
  typeComponentCorporate,
  typeComponentLifeInsurance,
  typeComponentNonBank,
  typeComponentNonLifeInsurance,
  typeComponentSecurity,
  typeViewBy,
} from '../constant'

const getDetailPanel = (type, setting = {}) => {
  switch (type) {
    // corporate
    case typeComponentCorporate.QUICK_ASSESSMENT:
      return {
        id: getUnique(),
        key: typeComponentCorporate.QUICK_ASSESSMENT,
        label: 'financialAnalysis.QUICK_ASSESSMENT',
        type: panelTypes.FULL_SIZE,
        viewByActive: typeViewBy.TABLE,
      }
    case typeComponentCorporate.PROFITABILITY:
      return {
        id: getUnique(),
        key: typeComponentCorporate.PROFITABILITY,
        label: 'financialAnalysis.PROFITABILITY',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.EACH_YEAR, typeViewBy.TABLE],
        viewByActive: typeViewBy.TREND,
        setting: {
          checked: ['FA165', 'RT0048', 'RT0050', 'RT0051', 'RT0052', 'RT0054'],
          year: null,
          ...setting,
        },
      }
    case typeComponentCorporate.ROA_AND_ROE:
      return {
        id: getUnique(),
        key: typeComponentCorporate.ROA_AND_ROE,
        label: 'financialAnalysis.ROA_AND_ROE',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.EACH_YEAR, typeViewBy.TABLE],
        viewByActive: typeViewBy.EACH_YEAR,
        setting: {
          year: null,
          ...setting,
        },
      }
    case typeComponentCorporate.ASSET_MANAGEMENT_EFFICIENCY:
      return {
        id: getUnique(),
        key: typeComponentCorporate.ASSET_MANAGEMENT_EFFICIENCY,
        label: 'financialAnalysis.ASSET_MANAGEMENT_EFFICIENCY',
        type: panelTypes.FULL_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.EACH_YEAR, typeViewBy.TABLE],
        viewByActive: typeViewBy.EACH_YEAR,
        height: 380,
        setting: {
          year: null,
          ...setting,
        },
      }
    case typeComponentCorporate.LIQUIDITY:
      return {
        id: getUnique(),
        key: typeComponentCorporate.LIQUIDITY,
        label: 'financialAnalysis.LIQUIDITY',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.EACH_YEAR, typeViewBy.TABLE],
        viewByActive: typeViewBy.EACH_YEAR,
        setting: {
          year: null,
          ...setting,
        },
      }
    case typeComponentCorporate.SOLVENCY:
      return {
        id: getUnique(),
        key: typeComponentCorporate.SOLVENCY,
        label: 'financialAnalysis.SOLVENCY',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.EACH_YEAR, typeViewBy.TABLE],
        viewByActive: typeViewBy.TREND,
        setting: {
          checked: [
            'RT0027',
            'RT0034',
            'RTI0027',
            'RTI0034',
            'RT0037',
            'RTI0037',
          ],
          year: null,
          ...setting,
        },
      }
    case typeComponentCorporate.COVERAGE:
      return {
        id: getUnique(),
        key: typeComponentCorporate.COVERAGE,
        label: 'financialAnalysis.COVERAGE',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.TABLE],
        viewByActive: typeViewBy.TREND,
        setting: {
          checked: ['RT0044', 'RT0045', 'RT0046', 'RT0047'],
          year: null,
          ...setting,
        },
      }
    case typeComponentCorporate.EARNING_BREAKDOWN:
      return {
        id: getUnique(),
        key: typeComponentCorporate.EARNING_BREAKDOWN,
        label: 'financialAnalysis.EARNING_BREAKDOWN',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.EACH_YEAR, typeViewBy.TABLE],
        viewByActive: typeViewBy.EACH_YEAR,
        setting: {
          checked: [
            'FA165',
            'FA164',
            'FA029',
            'FA189',
            'FA168',
            'FA162',
            'FA167',
            'FA166',
          ],
          year: null,
          ...setting,
        },
      }
    case typeComponentCorporate.BALANCE_BREAKDOWN:
      return {
        id: getUnique(),
        key: typeComponentCorporate.BALANCE_BREAKDOWN,
        label: 'financialAnalysis.BALANCE_BREAKDOWN',
        type: panelTypes.FULL_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.EACH_YEAR, typeViewBy.TABLE],
        viewByActive: typeViewBy.EACH_YEAR,
        setting: {
          checked: [
            //ASSET_STRUCTURE
            'BS2',
            'FA003',
            'FA004',
            'BS18',
            'FA005',
            'FA006',
            'BS64',
            'RT0172',
            //LIABILITIES_STRUCTURE
            'FA013',
            'FA016',
            'FA015',
            'FA014',
            'FA017',
            'BS65',
            'FA018',
            //EQUITY_STRUCTURE
            'FA024',
            'BS109',
            'FA025',
            'BS95',
            'RT0173',
          ],
          year: null,
          ...setting,
        },
      }
    case typeComponentCorporate.CASH_BREAKDOWN:
      return {
        id: getUnique(),
        key: typeComponentCorporate.CASH_BREAKDOWN,
        label: 'financialAnalysis.CASH_BREAKDOWN',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.TABLE],
        viewByActive: typeViewBy.TREND,
        setting: {
          checked: ['CF19', 'CF30', 'CF37', 'CF38'],
          year: null,
          ...setting,
        },
      }
    // bank
    case typeComponentBank.QUICK_ASSESSMENT:
      return {
        id: getUnique(),
        key: typeComponentBank.QUICK_ASSESSMENT,
        label: 'financialAnalysis.QUICK_ASSESSMENT',
        type: panelTypes.FULL_SIZE,
        viewByActive: typeViewBy.TABLE,
      }
    case typeComponentBank.LOAN_BOOK_BREAKDOWN:
      return {
        id: getUnique(),
        key: typeComponentBank.LOAN_BOOK_BREAKDOWN,
        label: 'financialAnalysis.LOAN_BOOK_BREAKDOWN',
        type: panelTypes.FULL_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.TABLE],
        viewByActive: typeViewBy.TREND,
        setting: {
          checked: [
            'NB66',
            'NB67',
            'NB68',
            'NB69',
            'NB70',
            'FA146',
            'FA147',
            'NB72',
            'NB73',
            'NB74',
          ],
          year: null,
          ...setting,
        },
      }
    case typeComponentBank.DEPOSIT_AND_CREDIT:
      return {
        id: getUnique(),
        key: typeComponentBank.DEPOSIT_AND_CREDIT,
        label: 'financialAnalysis.DEPOSIT_AND_CREDIT',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.TABLE],
        viewByActive: typeViewBy.TREND,
        setting: {
          checked: ['BS178', 'BS158', 'RT0297', 'RT0296'],
          year: null,
          ...setting,
        },
      }
    case typeComponentBank.AVERAGE_COST:
      return {
        id: getUnique(),
        key: typeComponentBank.AVERAGE_COST,
        label: 'financialAnalysis.AVERAGE_COST',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.TABLE],
        viewByActive: typeViewBy.TREND,
        setting: {
          checked: ['FA149', 'RT0239', 'FA061'],
          year: null,
          ...setting,
        },
      }
    case typeComponentBank.EARNING_QUALITY:
      return {
        id: getUnique(),
        key: typeComponentBank.EARNING_QUALITY,
        label: 'financialAnalysis.EARNING_QUALITY',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.TABLE],
        viewByActive: typeViewBy.TREND,
        setting: {
          year: null,
          ...setting,
        },
      }
    case typeComponentBank.CAPITAL_AND_LEVERAGE:
      return {
        id: getUnique(),
        key: typeComponentBank.CAPITAL_AND_LEVERAGE,
        label: 'financialAnalysis.CAPITAL_AND_LEVERAGE',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.TABLE],
        viewByActive: typeViewBy.TREND,
        setting: {
          year: null,
          ...setting,
        },
      }
    case typeComponentBank.LIQUIDITY:
      return {
        id: getUnique(),
        key: typeComponentBank.LIQUIDITY,
        label: 'financialAnalysis.LIQUIDITY',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.TABLE],
        viewByActive: typeViewBy.TREND,
        setting: {
          year: null,
          ...setting,
        },
      }
    case typeComponentBank.FUNDING_STRUCTURE:
      return {
        id: getUnique(),
        key: typeComponentBank.FUNDING_STRUCTURE,
        label: 'financialAnalysis.FUNDING_STRUCTURE',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.EACH_YEAR, typeViewBy.TABLE],
        viewByActive: typeViewBy.EACH_YEAR,
        setting: {
          checked: ['BS178', 'BS174', 'BS175', 'BS180', 'BS181', 'FA031'],
          year: null,
          ...setting,
        },
      }
    case typeComponentBank.BALANCE_BREAKDOWN:
      return {
        id: getUnique(),
        key: typeComponentBank.BALANCE_BREAKDOWN,
        label: 'financialAnalysis.BALANCE_BREAKDOWN',
        type: panelTypes.FULL_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.EACH_YEAR, typeViewBy.TABLE],
        viewByActive: typeViewBy.EACH_YEAR,
        setting: {
          checked: [
            //ASSET_STRUCTURE
            'BS2',
            'FA037',
            'FA038',
            'BS158',
            'FA039',
            'FA040',
            'RT0296',
            'RT0172',
            //LIABILITIES_STRUCTURE
            'BS174',
            'BS175',
            'BS178',
            'BS181',
            'FA047',
            'FA048',
            //EQUITY_STRUCTURE
            'BS186',
            'BS187',
            'BS109',
            'FA054',
            'RT0173',
          ],
          year: null,
          ...setting,
        },
      }
    case typeComponentBank.EARNING_BREAKDOWN:
      return {
        id: getUnique(),
        key: typeComponentBank.EARNING_BREAKDOWN,
        label: 'financialAnalysis.EARNING_BREAKDOWN',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.EACH_YEAR, typeViewBy.TABLE],
        viewByActive: typeViewBy.EACH_YEAR,
        setting: {
          checked: ['IS27', 'IS30', 'FA059', 'IS39', 'IS41', 'IS16'],
          year: null,
          ...setting,
        },
      }
    case typeComponentBank.CASH_FLOW:
      return {
        id: getUnique(),
        key: typeComponentBank.CASH_FLOW,
        label: 'financialAnalysis.CASH_BREAKDOWN',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.TABLE],
        viewByActive: typeViewBy.TREND,
        setting: {
          checked: ['CF19', 'CF30', 'CF37', 'CF38'],
          year: null,
          ...setting,
        },
      }
    // non bank
    case typeComponentNonBank.QUICK_ASSESSMENT:
      return {
        id: getUnique(),
        key: typeComponentNonBank.QUICK_ASSESSMENT,
        label: 'financialAnalysis.QUICK_ASSESSMENT',
        type: panelTypes.FULL_SIZE,
        viewByActive: typeViewBy.TABLE,
      }
    case typeComponentNonBank.LOAN_BOOK_BREAKDOWN:
      return {
        id: getUnique(),
        key: typeComponentNonBank.LOAN_BOOK_BREAKDOWN,
        label: 'financialAnalysis.LOAN_BOOK_BREAKDOWN',
        type: panelTypes.FULL_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.TABLE],
        viewByActive: typeViewBy.TREND,
        setting: {
          checked: [
            'NB66',
            'NB67',
            'NB68',
            'NB69',
            'NB70',
            'FA146',
            'FA147',
            'NB72',
            'NB73',
            'NB74',
          ],
          year: null,
          ...setting,
        },
      }
    case typeComponentNonBank.DEPOSIT_AND_CREDIT:
      return {
        id: getUnique(),
        key: typeComponentNonBank.DEPOSIT_AND_CREDIT,
        label: 'financialAnalysis.DEPOSIT_AND_CREDIT',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.TABLE],
        viewByActive: typeViewBy.TREND,
        setting: {
          checked: ['BS178', 'BS158', 'RT0297', 'RT0296'],
          year: null,
          ...setting,
        },
      }
    case typeComponentNonBank.AVERAGE_COST:
      return {
        id: getUnique(),
        key: typeComponentNonBank.AVERAGE_COST,
        label: 'financialAnalysis.AVERAGE_COST',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.TABLE],
        viewByActive: typeViewBy.TREND,
        setting: {
          checked: ['FA149', 'RT0239', 'FA061'],
          year: null,
          ...setting,
        },
      }
    case typeComponentNonBank.EARNING_QUALITY:
      return {
        id: getUnique(),
        key: typeComponentNonBank.EARNING_QUALITY,
        label: 'financialAnalysis.EARNING_QUALITY',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.TABLE],
        viewByActive: typeViewBy.TREND,
        setting: {
          year: null,
          ...setting,
        },
      }
    case typeComponentNonBank.CAPITAL_AND_LEVERAGE:
      return {
        id: getUnique(),
        key: typeComponentNonBank.CAPITAL_AND_LEVERAGE,
        label: 'financialAnalysis.CAPITAL_AND_LEVERAGE',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.TABLE],
        viewByActive: typeViewBy.TREND,
        setting: {
          year: null,
          ...setting,
        },
      }
    case typeComponentNonBank.LIQUIDITY:
      return {
        id: getUnique(),
        key: typeComponentNonBank.LIQUIDITY,
        label: 'financialAnalysis.LIQUIDITY',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.TABLE],
        viewByActive: typeViewBy.TREND,
        setting: {
          year: null,
          ...setting,
        },
      }
    case typeComponentNonBank.FUNDING_STRUCTURE:
      return {
        id: getUnique(),
        key: typeComponentNonBank.FUNDING_STRUCTURE,
        label: 'financialAnalysis.FUNDING_STRUCTURE',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.EACH_YEAR, typeViewBy.TABLE],
        viewByActive: typeViewBy.EACH_YEAR,
        setting: {
          checked: ['BS178', 'BS174', 'BS175', 'BS180', 'BS181', 'FA031'],
          year: null,
          ...setting,
        },
      }
    case typeComponentNonBank.BALANCE_BREAKDOWN:
      return {
        id: getUnique(),
        key: typeComponentNonBank.BALANCE_BREAKDOWN,
        label: 'financialAnalysis.BALANCE_BREAKDOWN',
        type: panelTypes.FULL_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.EACH_YEAR, typeViewBy.TABLE],
        viewByActive: typeViewBy.EACH_YEAR,
        setting: {
          checked: [
            //ASSET_STRUCTURE
            'BS2',
            'FA037',
            'FA038',
            'BS158',
            'FA039',
            'FA040',
            'RT0296',
            'RT0172',
            //LIABILITIES_STRUCTURE
            'BS174',
            'BS175',
            'BS178',
            'BS181',
            'FA047',
            'FA048',
            //EQUITY_STRUCTURE
            'BS186',
            'BS187',
            'BS109',
            'FA054',
            'RT0173',
          ],
          year: null,
          ...setting,
        },
      }
    case typeComponentNonBank.EARNING_BREAKDOWN:
      return {
        id: getUnique(),
        key: typeComponentNonBank.EARNING_BREAKDOWN,
        label: 'financialAnalysis.EARNING_BREAKDOWN',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.EACH_YEAR, typeViewBy.TABLE],
        viewByActive: typeViewBy.EACH_YEAR,
        setting: {
          checked: ['IS27', 'IS30', 'FA059', 'IS39', 'IS41', 'IS16'],
          year: null,
          ...setting,
        },
      }
    case typeComponentNonBank.CASH_FLOW:
      return {
        id: getUnique(),
        key: typeComponentNonBank.CASH_FLOW,
        label: 'financialAnalysis.CASH_BREAKDOWN',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.TABLE],
        viewByActive: typeViewBy.TREND,
        setting: {
          checked: ['CF19', 'CF30', 'CF37', 'CF38'],
          year: null,
          ...setting,
        },
      }
    // security
    case typeComponentSecurity.OPERATING_INCOME:
      return {
        id: getUnique(),
        key: typeComponentSecurity.OPERATING_INCOME,
        label: 'financialAnalysis.OPERATING_INCOME',
        height: 370,
        type: panelTypes.FULL_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.EACH_YEAR, typeViewBy.TABLE],
        viewByActive: typeViewBy.EACH_YEAR,
        setting: {
          checked: [
            'FA062',
            'IS111',
            'IS114',
            'FA063',
            'FA064',
            'IS106',
            'IS110',
            'IS112',
          ],
          year: null,
          ...setting,
        },
      }
    case typeComponentSecurity.BUSINESS_POSITION:
      return {
        id: getUnique(),
        key: typeComponentSecurity.BUSINESS_POSITION,
        label: 'financialAnalysis.BUSINESS_POSITION',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.TABLE],
        viewByActive: typeViewBy.TREND,
        setting: {
          checked: ['IS3', 'BS64', 'FA073', 'FA074'],
          year: null,
          ...setting,
        },
      }
    case typeComponentSecurity.FINANCIAL_ASSET:
      return {
        id: getUnique(),
        key: typeComponentSecurity.FINANCIAL_ASSET,
        label: 'financialAnalysis.FINANCIAL_ASSET',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.EACH_YEAR, typeViewBy.TABLE],
        viewByActive: typeViewBy.EACH_YEAR,
        setting: {
          checked: ['BS249', 'FA075', 'FA076', 'FA077'],
          year: null,
          ...setting,
        },
      }
    case typeComponentSecurity.EARNING_QUALITY:
      return {
        id: getUnique(),
        key: typeComponentSecurity.EARNING_QUALITY,
        label: 'financialAnalysis.EARNING_QUALITY',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.TABLE],
        viewByActive: typeViewBy.TREND,
        setting: {
          year: null,
          ...setting,
        },
      }
    case typeComponentSecurity.LEVERAGE:
      return {
        id: getUnique(),
        key: typeComponentSecurity.LEVERAGE,
        label: 'financialAnalysis.LEVERAGE',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.TABLE],
        viewByActive: typeViewBy.TREND,
        setting: {
          year: null,
          ...setting,
        },
      }
    case typeComponentSecurity.FUNDING_AND_LIQUIDITY:
      return {
        id: getUnique(),
        key: typeComponentSecurity.FUNDING_AND_LIQUIDITY,
        label: 'financialAnalysis.FUNDING_AND_LIQUIDITY',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.TABLE],
        viewByActive: typeViewBy.TREND,
        setting: {
          checked: ['FA085', 'FA086', 'FA087', 'FA088'],
          year: null,
          ...setting,
        },
      }
    case typeComponentSecurity.EARNING_BREAKDOWN:
      return {
        id: getUnique(),
        key: typeComponentSecurity.EARNING_BREAKDOWN,
        label: 'financialAnalysis.EARNING_BREAKDOWN',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.EACH_YEAR, typeViewBy.TABLE],
        viewByActive: typeViewBy.EACH_YEAR,
        setting: {
          checked: [
            'IS3',
            'IS6',
            'IS7',
            'IS4',
            'FA089',
            'IS13',
            'IS14',
            // 'FA161',
            'IS16',
          ],
          year: null,
          ...setting,
        },
      }
    case typeComponentSecurity.BALANCE_BREAKDOWN:
      return {
        id: getUnique(),
        key: typeComponentSecurity.BALANCE_BREAKDOWN,
        label: 'financialAnalysis.BALANCE_BREAKDOWN',
        type: panelTypes.FULL_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.EACH_YEAR, typeViewBy.TABLE],
        viewByActive: typeViewBy.EACH_YEAR,
        setting: {
          checked: [
            //ASSET_STRUCTURE
            'FA090',
            'BS250',
            'BS265',
            'BS36',
            'BS46',
            'BS49',
            'FA091',
            'RT0172',
            //LIABILITIES_STRUCTURE
            'BS66',
            'BS81',
            'FA099',
            //EQUITY_STRUCTURE
            'BS293',
            'BS294',
            'BS138',
            'BS109',
            'FA102',
            'RT0173',
          ],
          year: null,
          ...setting,
        },
      }
    case typeComponentSecurity.CASH_FLOW:
      return {
        id: getUnique(),
        key: typeComponentSecurity.CASH_FLOW,
        label: 'financialAnalysis.CASH_BREAKDOWN',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.TABLE],
        viewByActive: typeViewBy.TREND,
        setting: {
          checked: ['CF19', 'CF30', 'CF37', 'CF38'],
          year: null,
          ...setting,
        },
      }
    // life insurance
    case typeComponentLifeInsurance.INSURANCE_PREMIUM_REVENUE:
      return {
        id: getUnique(),
        key: typeComponentLifeInsurance.INSURANCE_PREMIUM_REVENUE,
        label: 'financialAnalysis.INSURANCE_PREMIUM_REVENUE',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.TABLE],
        viewByActive: typeViewBy.TREND,
        setting: {
          checked: ['IS1', 'IS45', 'IS51', 'FA269', 'RT0418', 'RT0419'],
          year: null,
          ...setting,
        },
      }
    case typeComponentLifeInsurance.OPERATIONAL_EFFICIENCY:
      return {
        id: getUnique(),
        key: typeComponentLifeInsurance.OPERATIONAL_EFFICIENCY,
        label: 'financialAnalysis.OPERATIONAL_EFFICIENCY',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.EACH_YEAR, typeViewBy.TABLE],
        viewByActive: typeViewBy.TREND,
        setting: {
          checked: [
            'RT2017',
            'RTG2017',
            'RT0420',
            'RTG0420',
            'RT2018',
            'RTG2018',
          ],
          year: null,
          ...setting,
        },
      }
    case typeComponentLifeInsurance.PROFITABILITY:
      return {
        id: getUnique(),
        key: typeComponentLifeInsurance.PROFITABILITY,
        label: 'financialAnalysis.PROFITABILITY',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.TABLE],
        viewByActive: typeViewBy.TREND,
        setting: {
          checked: [
            'IS51',
            'IS91',
            'IS94',
            'IS16',
            'RT0050',
            'RT0416',
            'RT2002',
          ],
          year: null,
          ...setting,
        },
      }
    case typeComponentLifeInsurance.ROA_AND_ROE:
      return {
        id: getUnique(),
        key: typeComponentLifeInsurance.ROA_AND_ROE,
        label: 'financialAnalysis.ROA_AND_ROE',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.EACH_YEAR, typeViewBy.TABLE],
        viewByActive: typeViewBy.EACH_YEAR,
        setting: {
          year: null,
          ...setting,
        },
      }
    case typeComponentLifeInsurance.INSURANCE_SOLVENCY:
      return {
        id: getUnique(),
        key: typeComponentLifeInsurance.INSURANCE_SOLVENCY,
        label: 'financialAnalysis.INSURANCE_SOLVENCY',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.TABLE],
        viewByActive: typeViewBy.TREND,
        setting: {
          checked: ['RT0033', 'RTG0033', 'RT0417', 'RTG0417'],
          year: null,
          ...setting,
        },
      }
    case typeComponentLifeInsurance.LIQUIDITY:
      return {
        id: getUnique(),
        key: typeComponentLifeInsurance.LIQUIDITY,
        label: 'financialAnalysis.LIQUIDITY',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.EACH_YEAR, typeViewBy.TABLE],
        viewByActive: typeViewBy.EACH_YEAR,
        setting: {
          year: null,
          ...setting,
        },
      }
    case typeComponentLifeInsurance.EARNING_BREAKDOWN:
      return {
        id: getUnique(),
        key: typeComponentLifeInsurance.EARNING_BREAKDOWN,
        label: 'financialAnalysis.EARNING_BREAKDOWN',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.EACH_YEAR, typeViewBy.TABLE],
        viewByActive: typeViewBy.EACH_YEAR,
        setting: {
          checked: [
            'FA304',
            'FA305',
            'FA306',
            'FA307',
            'FA308',
            'FA309',
            'FA310',
            'FA311',
            'FA312',
            'FA314',
            'FA315',
            'FA317',
            'FA318',
            'FA320',
            'FA321',
            'FA322',
            'FA323',
          ],
          year: null,
          ...setting,
        },
      }
    case typeComponentLifeInsurance.BALANCE_BREAKDOWN:
      return {
        id: getUnique(),
        key: typeComponentLifeInsurance.BALANCE_BREAKDOWN,
        label: 'financialAnalysis.BALANCE_BREAKDOWN',
        type: panelTypes.FULL_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.EACH_YEAR, typeViewBy.TABLE],
        viewByActive: typeViewBy.EACH_YEAR,
        setting: {
          checked: [
            //ASSET_STRUCTURE
            'BS2',
            'BS5',
            'BS9',
            'BS217',
            'BS36',
            'BS46',
            'BS52',
            'FA201',
            'RT0172',
            //LIABILITIES_STRUCTURE
            'BS66',
            'BS229',
            'FA210',
            'FA018',
            //EQUITY_STRUCTURE
            'FA024',
            'BS109',
            'FA025',
            'RT0173',
          ],
          year: null,
          ...setting,
        },
      }
    case typeComponentLifeInsurance.CASH_FLOW:
      return {
        id: getUnique(),
        key: typeComponentLifeInsurance.CASH_FLOW,
        label: 'financialAnalysis.CASH_BREAKDOWN',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.TABLE],
        viewByActive: typeViewBy.TREND,
        setting: {
          checked: ['CF38', 'CF37', 'CF30', 'CF19'],
          year: null,
          ...setting,
        },
      }
    // non life insurance
    case typeComponentNonLifeInsurance.INSURANCE_PREMIUM_REVENUE:
      return {
        id: getUnique(),
        key: typeComponentNonLifeInsurance.INSURANCE_PREMIUM_REVENUE,
        label: 'financialAnalysis.INSURANCE_PREMIUM_REVENUE',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.TABLE],
        viewByActive: typeViewBy.TREND,
        setting: {
          checked: ['IS1', 'IS45', 'IS51', 'FA269', 'RT0418', 'RT0419'],
          year: null,
          ...setting,
        },
      }
    case typeComponentNonLifeInsurance.OPERATIONAL_EFFICIENCY:
      return {
        id: getUnique(),
        key: typeComponentNonLifeInsurance.OPERATIONAL_EFFICIENCY,
        label: 'financialAnalysis.OPERATIONAL_EFFICIENCY',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.EACH_YEAR, typeViewBy.TABLE],
        viewByActive: typeViewBy.TREND,
        setting: {
          checked: [
            'RT2017',
            'RTG2017',
            'RT0420',
            'RTG0420',
            'RT2018',
            'RTG2018',
          ],
          year: null,
          ...setting,
        },
      }
    case typeComponentNonLifeInsurance.PROFITABILITY:
      return {
        id: getUnique(),
        key: typeComponentNonLifeInsurance.PROFITABILITY,
        label: 'financialAnalysis.PROFITABILITY',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.TABLE],
        viewByActive: typeViewBy.TREND,
        setting: {
          checked: [
            'IS51',
            'IS91',
            'IS94',
            'IS16',
            'RT0050',
            'RT0416',
            'RT2002',
          ],
          year: null,
          ...setting,
        },
      }
    case typeComponentNonLifeInsurance.ROA_AND_ROE:
      return {
        id: getUnique(),
        key: typeComponentNonLifeInsurance.ROA_AND_ROE,
        label: 'financialAnalysis.ROA_AND_ROE',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.EACH_YEAR, typeViewBy.TABLE],
        viewByActive: typeViewBy.EACH_YEAR,
        setting: {
          year: null,
          ...setting,
        },
      }
    case typeComponentNonLifeInsurance.INSURANCE_SOLVENCY:
      return {
        id: getUnique(),
        key: typeComponentNonLifeInsurance.INSURANCE_SOLVENCY,
        label: 'financialAnalysis.INSURANCE_SOLVENCY',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.TABLE],
        viewByActive: typeViewBy.TREND,
        setting: {
          checked: ['RT0033', 'RTG0033', 'RT0417', 'RTG0417'],
          year: null,
          ...setting,
        },
      }
    case typeComponentNonLifeInsurance.LIQUIDITY:
      return {
        id: getUnique(),
        key: typeComponentNonLifeInsurance.LIQUIDITY,
        label: 'financialAnalysis.LIQUIDITY',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.EACH_YEAR, typeViewBy.TABLE],
        viewByActive: typeViewBy.EACH_YEAR,
        setting: {
          year: null,
          ...setting,
        },
      }
    case typeComponentNonLifeInsurance.EARNING_BREAKDOWN:
      return {
        id: getUnique(),
        key: typeComponentNonLifeInsurance.EARNING_BREAKDOWN,
        label: 'financialAnalysis.EARNING_BREAKDOWN',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.EACH_YEAR, typeViewBy.TABLE],
        viewByActive: typeViewBy.EACH_YEAR,
        setting: {
          checked: [
            'FA324',
            'FA325',
            'FA326',
            'FA327',
            'FA328',
            'FA329',
            'FA330',
            'FA331',
            'FA332',
            'FA333',
            'FA334',
            'FA335',
            'FA336',
            'FA337',
            'FA338',
            'FA339',
            'FA340',
            'FA341',
            'FA342',
            'FA343',
            'FA344',
          ],
          year: null,
          ...setting,
        },
      }
    case typeComponentNonLifeInsurance.BALANCE_BREAKDOWN:
      return {
        id: getUnique(),
        key: typeComponentNonLifeInsurance.BALANCE_BREAKDOWN,
        label: 'financialAnalysis.BALANCE_BREAKDOWN',
        type: panelTypes.FULL_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.EACH_YEAR, typeViewBy.TABLE],
        viewByActive: typeViewBy.EACH_YEAR,
        setting: {
          checked: [
            //ASSET_STRUCTURE
            'BS2',
            'BS5',
            'BS9',
            'BS217',
            'BS36',
            'BS46',
            'BS52',
            'FA201',
            'RT0172',
            //LIABILITIES_STRUCTURE
            'BS76',
            'BS67',
            'BS229',
            'FA223',
            'BS81',
            'FA018',
            //EQUITY_STRUCTURE
            'FA024',
            'BS109',
            'FA025',
            'RT0173',
          ],
          year: null,
          ...setting,
        },
      }
    case typeComponentNonLifeInsurance.CASH_FLOW:
      return {
        id: getUnique(),
        key: typeComponentNonLifeInsurance.CASH_FLOW,
        label: 'financialAnalysis.CASH_BREAKDOWN',
        type: panelTypes.HALF_SIZE,
        viewByList: [typeViewBy.TREND, typeViewBy.TABLE],
        viewByActive: typeViewBy.TREND,
        setting: {
          checked: ['CF38', 'CF37', 'CF30', 'CF19'],
          year: null,
          ...setting,
        },
      }
    default:
      return
  }
}

export default getDetailPanel
